module.exports = __webpack_public_path__ + "static/b1-social-491399759b514a5b9fb4d44afa48b687.jpg";